export enum Component {
  // N.B. that there is no "unknown" or "misc" component.
  // You can add such a catch-all to this enum,
  // but we would encourage you to consider adding
  // a new product area instead of such a concept.
  Analytics = "Analytics",
  AdminTools = "Admin Tools",
  BackpackStorybook = "Backpack Storybook",
  BuyerOrgs = "Buyer Orgs",
  CategoryPages = "Category Pages",
  Classroom = "Classroom",
  ContentModeration = "Content Moderation",
  DataDeletion = "Data Deletion",
  PublicFunding = "Public Funding",
  EmailNotifications = "Email Notifications",
  EnrollmentsParent = "Enrollments for Parents",
  EnrollmentsTeacher = "Enrollments for Teachers",
  ExperimentationFramework = "Experimentation Framework",
  FilestackMigration = "Filestack Migration",
  Infra = "Infra",
  International = "International",
  IpLookupService = "IP Lookup Service",
  LearnerDataPipeline = "Learner Data Pipeline",
  LearnerMode = "Learner Mode / Learner UX (Learner privacy, learner accounts)",
  LearnerApp = "Learner App",
  Marketing = "Marketing",
  MediaApp = "Media App: Image Transformations",
  Messaging = "Messaging",
  Notifications = "Notifications",
  Orders = "Orders",
  ParentAdminTools = "Parent CX and Admin Tools",
  ParentEmailNotifications = "Parent Email Notifications",
  Payouts = "Payouts",
  QuizWriter = "Quiz Writer",
  Recommendations = "Recommendations",
  Recordings = "Recordings",
  ReferralProgram = "Referral Program",
  UserAdmin = "User Admin",
  SEOTaxonomy = "SEO Taxonomy",
  Search = "Search",
  Subscriptions = "Subscriptions",
  SearchRanking = "SearchRanking",
  Sitemap = "Sitemap",
  TeacherAdminTools = "Teacher CX and Admin Tools",
  TeacherTools = "Teacher Tools",
  Tracking = "Tracking",
  TrustMonitoring = "Trust and Safety Monitoring",
  TrustOs = "Trust OS",
  Tutoring = "Tutoring",
  UserAccountManagement = "User Account Management",
  Website = "Website",
  Zoom = "Zoom",
  ZoomChats = "Zoom Chats",
}

export enum EngineeringTeams {
  AllTeams = "AllTeams",
  Infra = "Infra",
  Product = "Product",
  Analytics = "Analytics",
}

// Source: https://docs.google.com/spreadsheets/d/1POCSFvOABgU3nCChhcqQ6tBStlBs9Zxtq1skX_eKXtc/edit?gid=987463074#gid=987463074
export const OwnershipAreas: Record<Component, EngineeringTeams> = {
  [Component.Website]: EngineeringTeams.AllTeams,
  [Component.Analytics]: EngineeringTeams.Analytics,
  [Component.AdminTools]: EngineeringTeams.Product,
  [Component.BackpackStorybook]: EngineeringTeams.AllTeams,
  [Component.BuyerOrgs]: EngineeringTeams.Product,
  [Component.CategoryPages]: EngineeringTeams.Product,
  [Component.Classroom]: EngineeringTeams.Product,
  [Component.ContentModeration]: EngineeringTeams.Product,
  [Component.DataDeletion]: EngineeringTeams.Infra,
  [Component.PublicFunding]: EngineeringTeams.Product,
  [Component.EmailNotifications]: EngineeringTeams.Product,
  [Component.EnrollmentsParent]: EngineeringTeams.Product,
  [Component.EnrollmentsTeacher]: EngineeringTeams.Product,
  [Component.FilestackMigration]: EngineeringTeams.Infra,
  [Component.ExperimentationFramework]: EngineeringTeams.AllTeams,
  [Component.Infra]: EngineeringTeams.Infra,
  [Component.International]: EngineeringTeams.Product,
  [Component.IpLookupService]: EngineeringTeams.Product,
  [Component.LearnerDataPipeline]: EngineeringTeams.Infra,
  [Component.LearnerMode]: EngineeringTeams.Product,
  [Component.LearnerApp]: EngineeringTeams.Product,
  [Component.Marketing]: EngineeringTeams.Product,
  [Component.MediaApp]: EngineeringTeams.Infra,
  [Component.Messaging]: EngineeringTeams.Product,
  [Component.Notifications]: EngineeringTeams.Product,
  [Component.Orders]: EngineeringTeams.Product,
  [Component.ParentAdminTools]: EngineeringTeams.Product,
  [Component.ParentEmailNotifications]: EngineeringTeams.Product,
  [Component.Payouts]: EngineeringTeams.Product,
  [Component.Recommendations]: EngineeringTeams.Product,
  [Component.Recordings]: EngineeringTeams.Product,
  [Component.ReferralProgram]: EngineeringTeams.Product,
  [Component.UserAdmin]: EngineeringTeams.Product,
  [Component.SEOTaxonomy]: EngineeringTeams.Product,
  [Component.SearchRanking]: EngineeringTeams.Product,
  [Component.Search]: EngineeringTeams.Product,
  [Component.Subscriptions]: EngineeringTeams.Product,
  [Component.Sitemap]: EngineeringTeams.Product,
  [Component.TeacherAdminTools]: EngineeringTeams.Product,
  [Component.TeacherTools]: EngineeringTeams.Product,
  [Component.Tracking]: EngineeringTeams.AllTeams,
  [Component.TrustMonitoring]: EngineeringTeams.Product,
  [Component.TrustOs]: EngineeringTeams.Product,
  [Component.Tutoring]: EngineeringTeams.Product,
  [Component.UserAccountManagement]: EngineeringTeams.Product,
  [Component.Zoom]: EngineeringTeams.Product,
  [Component.ZoomChats]: EngineeringTeams.Product,
  [Component.QuizWriter]: EngineeringTeams.Product,
};
